import { FirebaseDbProvider } from '../../providers/firebase-db/firebase-db';
import { LanguageComponent } from '../../components/language/language.component';
import { AngularFireAuth } from '@angular/fire/auth';
import { LoadingComponent } from '../../components/loading/loading.component';
import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-language',
  templateUrl: './language.page.html',
  styleUrls: ['./language.page.scss']
})
export class LanguagePage implements OnInit {

  language: string;
  page: string;

  en_title = 'Languages';
  en_en = 'English';
  en_sp = 'Spanish';
  sp_title = 'Idiomas';
  sp_en = 'Inglés';
  sp_sp = 'Español';

  constructor(private _params: NavParams, private _load: LoadingComponent,
    private _auth: AngularFireAuth, private _ln: LanguageComponent,
    private _db: FirebaseDbProvider, private _view: PopoverController) {
      this.page = this._params.get('onRegister');
      // Solo sirve para registro
  }

  async ngOnInit() {
    if (this.page === 'options') {
      this.language = await this._ln.getLanguage(this._auth.auth.currentUser.uid);
    } else { this.language = this._params.get('current_lg'); }
  }

  async changeLanguage(new_language: string) {
    if (this.page === 'options') {
      this.language = await this._ln.getLanguage(this._auth.auth.currentUser.uid);
    } else { this.language = this._params.get('current_lg'); }

    if (this.language === 'sp' && new_language === 'en') {
      if (this.page === 'options') {
        await this._load.wait();
        const key: string = this._auth.auth.currentUser.uid;
        await this._db.updateLanguage('en', key);
        await this._load.quit_wait();
      }
      this.language = 'en';
      this._view.dismiss({
        language: this.language
      });
    } else if (this.language === 'en' && new_language === 'sp') {
      if (this.page === 'options') {
        await this._load.wait();
        const key: string = this._auth.auth.currentUser.uid;
        await this._db.updateLanguage('sp', key);
        await this._load.quit_wait();
      }
      this.language = 'sp';
      this._view.dismiss({
        language: this.language
      });
    } else { this._view.dismiss(); }
  }

}
